<div class="field" [ngClass]="{'error': validate()}">
  <input #input (keyup)="onKeyUp($event)" [(ngModel)]="value" style="width: 100%; padding-top: .25rem;">
</div>
